<template>
    <form @submit.prevent="submitForm">
        <div class="row">
            <div class="col-md-6">
                <field-text required v-model="form.title" label="عنوان" placeholder=""/>
                <field-image required v-model="form.image_src"
                             link="fa/v1/products/upload-image"
                             placeholder=""/>
                <field-select-tree required v-model="form.category_set" label="انتخاب دسته بندی" placeholder=""
                                   :radio="false" link="/fa/v1/product-categories/tree"/>
            </div>
            <div class="col-md-6">
                <field-markdown required v-model="form.specifications_fa" label="مشخصات فنی - فارسی" placeholder=""/>
                <field-markdown required v-model="form.specifications_en" label="مشخصات فنی - انگلیسی" placeholder=""/>

            </div>
        </div>

        <alert :success="success" :danger="danger"></alert>
        <button-submit title="ثبت"/>
    </form>
</template>

<script>
import ButtonSubmit from "../ButtonSubmit";
import Alert from "../Alert";
import FieldPassword from "../fields/FieldPassword";
import FieldMobile from "../fields/FieldMobile";
import FieldEmail from "../fields/FieldEmail";

import mixinForm from "../../mixins/mixinForm";
import FieldSelect from "../fields/FieldSelect";
import FieldText from "../fields/FieldText";
import FieldTextarea from "../fields/FieldTextarea";
import FieldSelectTree from "../fields/FieldSelectTree";
import FieldImage from "../fields/FieldImage";
import FieldMarkdown from "../fields/FieldMarkdown";

export default {
  mixins: [mixinForm],
  components: {
    FieldMarkdown,
    FieldImage,
    FieldSelectTree,
    FieldTextarea,
    FieldSelect,
    FieldText,
    FieldEmail,
    FieldMobile,
    FieldPassword,
    Alert,
    ButtonSubmit
  },
  name: "FormProduct",
  data() {
    return {
      action: "/fa/v1/products"
    };
  }
};
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/forms/FormProduct.vue